<template>
  <va-modal
    :value="isOpen"
    id="hearingTestModal"
    ref="hearingTestModal"
    :showOkay="false"
    @cancel="onClose"
    :fixedLayout="true"
    :hideDefaultActions="true"
    >
    <div slot="header" class="modal-title d-flex justify-content-between">
      <span>{{ $t('accounts.hearing_test') }}</span>
    </div>

    <div class="modal-header-actions d-flex justify-content-end" v-if="allowDownload">
      <va-popover
        placement="left"
        :message="$t('clinical.buttons.download_hearing_test'
        )">
        <va-button
          large
          class="va-button-rounded"
          icon="fa fa-download"
          color="gray"
          @click="download">
        </va-button>
      </va-popover>
    </div>
    <br>
    <div class="row">

      <div v-if="hearingTest.device_model" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('accounts.device')}}</label>
        <p>{{hearingTest.device_model}}</p>
      </div>

      <div v-if="hearingTest.device_brand" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('accounts.brand')}}</label>
        <p>{{hearingTest.device_brand}}</p>
      </div>

    </div>

    <div class="row">

      <div v-if="hearingTest.version" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('accounts.version')}}</label>
        <p>{{hearingTest.version}}</p>
      </div>

      <div v-if="hearingTest.volume" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('accounts.volume')}}</label>
        <p>{{hearingTest.volume}}</p>
      </div>

    </div>

    <div class="row">

      <div v-if="hearingTest.noise_right" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('accounts.noise_left')}}</label>
        <p>{{hearingTest.noise_right}}</p>
      </div>

      <div v-if="hearingTest.noise_left" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('accounts.noise_right')}}</label>
        <p>{{hearingTest.noise_left}}</p>
      </div>

    </div>

    <div class="row mb-3">

      <div v-if="hearingTest.hl_right" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('clinical.hearing_test.hl_left')}}</label>
        <p>{{hearingTest.hl_right}} dB HL</p>
      </div>

      <div v-if="hearingTest.hl_right" class="col-12 col-sm-6">
        <label class="is-bold">{{$t('clinical.hearing_test.hl_right')}}</label>
        <p>{{hearingTest.hl_right}} dB HL</p>
      </div>

    </div>

    <div>
      <va-chart
        id="hearingTestChart"
        type="line"
        :data="hearingTestChartData"
        :options="graphOptions"
      >
      </va-chart>
    </div>

  </va-modal>
</template>
<script>
import { AccountService } from '@/api/AuthClinicalService'
import HearingTestGraphOptionsMixin from '@/mixins/HearingTestGraphOptionsMixin'
export default {
  props: {
    hearingTest: {
      type: Object,
      required: true
    },
    service: {
      type:Object,
      required: false
    },
    allowDownload: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mixins: [
    HearingTestGraphOptionsMixin
  ],
  computed: {
    hearingTestChartData: function () {
      const resultsString = this.hearingTest.result

      let htValues = {
        frequencies: [],
        left: [],
        right: []
      }

      let rows = resultsString.split('\n')
      let frequencies = rows[0].split('\t')
      frequencies.splice(0, 1)

      htValues.frequencies = frequencies

      rows.splice(0, 1) // remove line with frequencies
      for (let row of rows) {
        let cols = row.split('\t')
        let side = cols[0]
        cols.splice(0, 1)
        let values = []
        if (side === 'L') {
          values = cols.map(function (item) {
            return -1 * parseInt(item, 10)
          })
          htValues.left = values
        } else {
          values = cols.map(function (item) {
            return -1 * parseInt(item, 10)
          })
          htValues.right = values
        }
      }

      let original = JSON.parse(JSON.stringify(htValues))

      htValues.frequencies.sort((a, b) => {
        return parseInt(a) - parseInt(b)
      })

      htValues.frequencies.forEach((frequency, index) => {
        let oldIndex = original.frequencies.findIndex(_frequency => parseInt(_frequency) === parseInt(frequency))
        htValues.left[index] = original.left[oldIndex]
        htValues.right[index] = original.right[oldIndex]
      })

      return {
        labels: htValues.frequencies,
        datasets: [
          {
            data: htValues.right,
            label: this.$t('clinical.labels.hl_right'),
            borderColor: '#ff0000'
          },
          {
            data: htValues.left,
            label: this.$t('clinical.labels.hl_left'),
            borderColor: '#0000ff'
          }
        ]
      }
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    download: function () {
      AccountService.downloadPDF(this.service.url, this.hearingTest.user_id, this.hearingTest.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.$t('clinical.accounts.hearing_test_result')}.pdf`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(errors => {
          this.showToast(this.$t('homelab.something_went_wrong'), this.$store.state.errorToastOptions)
        })
    },
    onClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
  #hearingTestChart {
    height: 250px;
  }
</style>
